export default "__VITE_ASSET__D$lj3haa__"